import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD_CAPITALSTATE}`

const fetchPagosEfectuados = (query) => http.get(`${api}/operation/pagos-efectuados`, { params: { ...query } })

export {
    fetchPagosEfectuados
}
